/**
 * Which clients get the AccessiBe overlay. Both the loader and the profile menu
 * toggle read this, so a client that never loads the script never sees a control
 * that would do nothing.
 *
 * This should become a module/config, or something else that can be enabled per Client.
 */
const enabledClientIds = [
  140, // BaxterStorey
  135, // Demo
  104, // SES
  137, // Page Demo
  60, // Page
  31, // Lexington
  130, // Rosas
  136, // RBH
  141, // HelloKorero
  48, // Valor
];

/** CSS class on `body` that hides the AccessiBe widget for the whole session. */
export const ACCESSIBE_HIDDEN_BODY_CLASS = "accessibility-tool-hidden";

export const isAccessibeEnabledForClient = (
  clientId: number | undefined
): boolean => {
  if (process.env.REACT_APP_ACCESSIBE_ENABLED?.toLowerCase()?.trim() !== "true")
    return false;

  if (!clientId) return false;

  return enabledClientIds.indexOf(clientId) >= 0;
};

export default isAccessibeEnabledForClient;
